module.exports = __webpack_public_path__ + "static/media/19.cabbec42.jpg";